import { VEHICLES } from "../reducers/actions/types/types";
const initialState = {
    vehicles: [],
    editVehicles: null
}

export const editVehicle = (state = initialState, action) => {
    switch (action.type) {
        case VEHICLES.GET_VEHICLES:
            return {
                ...state,
                vehicles: state.vehicles.map(vehicle => {
                    if (vehicle.id === action.payload.id) {
                        return {
                            ...vehicle,
                            ...action.payload.newData
                        };
                    }
                    return vehicle;
                })
            }
        case VEHICLES.SET_EDIT_VEHICLE:
            return {
                ...state,
                editVehicles: action.payload.editVehicle
            }
        case VEHICLES.DELETE_EDIT_VEHICLE:
            return {
                ...state,
                editVehicles: null
            }
        default:
            return state;
    }
}